import React from 'react';
import { Document, Page, Text, View, StyleSheet,Image } from '@react-pdf/renderer';
import logo from '../images/tiger.jpg';

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: 'Helvetica',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 30,
    borderBottomWidth: 1,
    borderBottomColor: '#CCCCCC',
    paddingBottom: 20,
  },
  companyName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: 'pink',
  },
  invoiceTitle: {
    fontSize: 20,
    color: '#7F8C8D',
  },
  infoSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 30,
    backgroundColor: '#F8F9FA',
    padding: 15,
    borderRadius: 5,
  },
  infoBlock: {
    flex: 1,
  },
  infoLabel: {
    fontSize: 10,
    color: '#7F8C8D',
    marginBottom: 3,
  },
  infoValue: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  customerSection: {
    marginBottom: 30,
    padding: 15,
    backgroundColor: '#F8F9FA',
    borderRadius: 5,
  },
  table: {
    display: 'flex',
    width: 'auto',
    marginBottom: 20,
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#2C3E50',
    color: 'white',
    padding: 10,
    fontWeight: 'bold',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    padding: 10,
  },
  description: {
    width: '40%',
  },
  quantity: {
    width: '15%',
    textAlign: 'right',
  },
  price: {
    width: '20%',
    textAlign: 'right',
  },
  vat: {
    width: '10%',
    textAlign: 'right',
  },
  total: {
    width: '15%',
    textAlign: 'right',
  },
  totals: {
    marginTop: 20,
    alignItems: 'flex-end',
  },
  totalRow: {
    flexDirection: 'row',
    padding: 5,
    width: '40%',
  },
  totalLabel: {
    flex: 1,
    textAlign: 'right',
    marginRight: 10,
  },
  totalValue: {
    width: 100,
    textAlign: 'right',
  },
  grandTotal: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#2C3E50',
    borderTopWidth: 2,
    borderTopColor: '#2C3E50',
    paddingTop: 10,
    marginTop: 5,
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    textAlign: 'center',
    color: '#7F8C8D',
    fontSize: 10,
    borderTopWidth: 1,
    borderTopColor: '#CCCCCC',
    paddingTop: 10,
  },
  vatNumber: {
    fontSize: 10,
    color: '#7F8C8D',
    marginTop: 5,
  },
logo: {
    width: 150,
    height: 50,
  },
});

// Calculate totals function
const calculateTotals = (items) => {
  let subtotal = 0;
  let vatTotal = 0;

  items.forEach(item => {
    const itemTotal = item.quantity * item.price;
    subtotal += itemTotal;
    vatTotal += itemTotal * (item.vatRate / 100);
  });

  return {
    subtotal,
    vatTotal,
    grandTotal: subtotal + vatTotal,
  };
};

// Invoice Document Component
const InvoicePDF = ({ data }) => {
  // Default data if none provided
  const invoiceData = data || {
    company: {
      name: 'Diamond Quality Constructions',
      address: 'Sharjah, UAE',
      vatNumber: '104836477000001',
      trn: '104836477000001',
    },
    invoice: {
      number: 'INV-2024-001',
      date: '2024-03-16',
      dueDate: '2024-04-15',
    },
    customer: {
      name: 'XYZ Enterprises',
      address: 'Abu Dhabi, UAE',
      vatNumber: '200123456700003',
    },
    items: [
      {
        description: 'Laptop Computer',
        quantity: 2,
        price: 3500,
        vatRate: 5,
      },
      {
        description: 'Wireless Mouse',
        quantity: 5,
        price: 75,
        vatRate: 5,
      },
    ],
  };

  const totals = calculateTotals(invoiceData.items);

  return (
    <Document>
      <Page size="A3" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <View>
           {/* logo */}
          <Image src={logo} style={styles.logo}/>
            <Text style={styles.companyName}>{invoiceData.company.name}</Text>
            <Text>{invoiceData.company.address}</Text>
            <Text style={styles.vatNumber}>VAT/TRN: {invoiceData.company.trn}</Text>
          </View>
          <View>
            <Text style={styles.invoiceTitle}>TAX INVOICE</Text>
          </View>
        </View>

        {/* Invoice Info */}
        <View style={styles.infoSection}>
          <View style={styles.infoBlock}>
            <Text style={styles.infoLabel}>Invoice Number</Text>
            <Text style={styles.infoValue}>{invoiceData.invoice.number}</Text>
          </View>
          <View style={styles.infoBlock}>
            <Text style={styles.infoLabel}>Invoice Date</Text>
            <Text style={styles.infoValue}>{invoiceData.invoice.date}</Text>
          </View>
          <View style={styles.infoBlock}>
            <Text style={styles.infoLabel}>Due Date</Text>
            <Text style={styles.infoValue}>{invoiceData.invoice.dueDate}</Text>
          </View>
        </View>

        {/* Customer Details */}
        <View style={styles.customerSection}>
          <Text style={styles.infoLabel}>Bill To:</Text>
          <Text style={styles.infoValue}>{invoiceData.customer.name}</Text>
          <Text>{invoiceData.customer.address}</Text>
          <Text style={styles.vatNumber}>VAT: {invoiceData.customer.vatNumber}</Text>
        </View>

        {/* Items Table */}
        <View style={styles.table}>
          {/* Table Header */}
          <View style={styles.tableHeader}>
            <Text style={styles.description}>Description</Text>
            <Text style={styles.quantity}>Qty</Text>
            <Text style={styles.price}>Price (AED)</Text>
            <Text style={styles.vat}>VAT%</Text>
            <Text style={styles.total}>Total (AED)</Text>
          </View>

          {/* Table Rows */}
          {invoiceData.items.map((item, index) => (
            <View key={index} style={styles.tableRow}>
              <Text style={styles.description}>{item.description}</Text>
              <Text style={styles.quantity}>{item.quantity}</Text>
              <Text style={styles.price}>{item.price.toFixed(2)}</Text>
              <Text style={styles.vat}>{item.vatRate}%</Text>
              <Text style={styles.total}>
                {(item.quantity * item.price).toFixed(2)}
              </Text>
            </View>
          ))}
        </View>

        {/* Totals Section */}
        <View style={styles.totals}>
          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>Subtotal:</Text>
            <Text style={styles.totalValue}>{totals.subtotal.toFixed(2)} AED</Text>
          </View>
          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>VAT (5%):</Text>
            <Text style={styles.totalValue}>{totals.vatTotal.toFixed(2)} AED</Text>
          </View>
          <View style={[styles.totalRow, styles.grandTotal]}>
            <Text style={styles.totalLabel}>Total:</Text>
            <Text style={styles.totalValue}>{totals.grandTotal.toFixed(2)} AED</Text>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text>This is a computer generated invoice. No signature required.</Text>
          <Text style={styles.vatNumber}>VAT registration number: {invoiceData.company.vatNumber}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default InvoicePDF;